<template>
  <v-treeview ref="f-treeview" :active="computedValue" :items="treeFeature" item-key="treeKey" open-all class="pb-5">
    <template #label="{ item }">
      <v-row no-gutters class="align-center" @click="activateElement(item.treeKey)">
        <v-col cols="auto" align-self="center">
          <span class="text-body-2">
            {{ item.metadata.title }}
          </span>
        </v-col>
        <v-col cols="auto" class="pl-1" align-self="center" v-if="item.metadata.subtitle">
          <span class="text-caption font-italic font-weight-light pa-0">
            {{ item.metadata.subtitle }}
          </span>
        </v-col>
      </v-row>
    </template>
    <template #append="{ item }">
      <v-row no-gutters class="align-center" @click="activateElement(item.treeKey)">
        <v-col cols="auto" v-if="item.metadata.badge">
          <v-tooltip bottom color="font">
            <template #activator="{ on }">
              <v-chip
                v-on="on"
                :color="item.metadata['badge_color'] || 'primary'"
                label
                small
                :class="{
                  'white--text': !$_isHexColorLight(item.metadata['badge_color'] || 'primary'),
                  'font--text': $_isHexColorLight(item.metadata['badge_color'] || 'primary'),
                }"
              >
                {{ item.metadata.badge }}
              </v-chip>
            </template>
            {{ item.metadata.badge }}
          </v-tooltip>
        </v-col>
        <v-col cols="auto">
          <slot name="additionalElements" v-bind="item"></slot>
        </v-col>
        <v-col cols="auto" v-if="item.dotsItems">
          <dots-menu :items="item.dotsItems" v-on="getListeners(item)" :disabled="isEditingOn" />
        </v-col>
      </v-row>
    </template>
  </v-treeview>
</template>

<script>
import DotsMenu from '@/components/DotsMenu.vue';
export default {
  name: 'FeatureTreeview',
  components: { DotsMenu },
  props: {
    isEditingOn: {
      type: Boolean,
      default: false,
    },
    treeFeature: {
      type: Array,
    },
    value: {
      type: String,
    },
  },
  computed: {
    computedValue() {
      return [this.value];
    },
  },
  methods: {
    activateElement(value) {
      if (this.isEditingOn) {
        return;
      }
      this.$emit('input', value);
    },
    getListeners(item) {
      const listeners = {};
      for (const action of item.dotsItems.map(dotsItem => dotsItem.name)) {
        listeners[action] = () => {
          this.$emit(`${action}TreeViewElement`, item);
        };
      }
      return listeners;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-treeview-node__root {
    cursor: pointer;
  }
  .v-treeview-node--active {
    &::after {
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      background-color: #1a73e8;
    }
  }
}
</style>
